export namespace CompanyTranslations {
  export const status = {
    companyStatus: 'companyStatus',
    demo: 'demo',
    trial: 'trial',
    active: 'active',
    expired: 'expired',
  } as const;
}
